import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CrisisBanner from "./CrisisBanner";
import CookieConsent from "./CookieConsent";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--tb-bg)]">
      <a href="#main" className="skip-link">Skip to main content</a>
      <CrisisBanner />
      <Navbar />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}
